import React from "react";
import {Redirect, Route, Switch} from "react-router";
import {ROUTES} from "../../../db/models/const";
import SchoolDashboard from "../SchoolDashboard/main";
import "./style.scss";

interface Props {
}

const SchoolMain: React.FC<Props> = () => {
    return (
        <section className="schoolMain container">
            <Switch>
                <Route path={ROUTES.ME} exact component={SchoolDashboard}/>
                <Redirect to={ROUTES.ME}/>
            </Switch>
        </section>
    );
};

export default SchoolMain;